const APIFY_API_TOKEN = process.env.REACT_APP_APIFY_API_TOKEN;

const INSTAGRAM_ACTOR =
    'supreme_coder~instagram-profile-scraper';


export const fetchInstagramStats = async (username) => {
    try {
        if (!APIFY_API_TOKEN) {
            const APIFY_API_TOKEN = process.env.REACT_APP_APIFY_API_TOKEN;

            console.log('>>>>>>>>>>>>>>>>>>>>>> Fetch From Instagram api');


            if (!APIFY_API_TOKEN) {
                console.error("REACT_APP_APIFY_API_TOKEN is missing from environment variables.");
            }

            return null;
        }

        const cleanUsername = username
            .replace('@', '')
            .trim();

        if (!cleanUsername) {
            console.error('Instagram username is required.');
            return null;
        }

        const url =
            `https://api.apify.com/v2/acts/${INSTAGRAM_ACTOR}` +
            `/run-sync-get-dataset-items`;

        const response = await fetch(url, {

            method: 'POST',

            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${APIFY_API_TOKEN}`,
            },

            body: JSON.stringify({
                usernames: [cleanUsername],

                // We only need profile information.
                // No need to scrape posts/highlights.
                scrapePosts: false,
                scrapeHighlights: false,
            }),
        });


        if (!response.ok) {
            const errorText = await response.text();

            console.error(
                'Instagram API error:',
                response.status,
                errorText
            );

            return null;
        }


        const data = await response.json();


        if (!Array.isArray(data) || data.length === 0) {
            console.error(
                'No Instagram profile data returned.'
            );

            return null;
        }


        const profile = data[0];


        return {
            username: profile.username,
            followers: profile.followersCount,
            following: profile.followsCount,
            posts: profile.postsCount,
            isVerified: profile.isVerified,
            isPrivate: profile.isPrivate,
            updatedAt: Date.now(),
        };

    } catch (error) {

        console.error(
            'Failed to fetch Instagram stats:',
            error
        );

        return null;
    }
};